// Endpoint specs:
// https://www.dropbox.com/scl/fi/31nxogj0nap0jy842z4sg/Payment-Page.paper?dl=0&rlkey=sx4z963m428xpb3tpar5sb92y#:uid=453743653446152325258227&h2=Endpoint:-Verify-Auth-Code

export const mockVerifyAuthCodeResponse = {
  success: true,
  user: {
    ID: 11167815,
    loginLevel: "full",
    name: "Mark Foster",
    photoURL: "https://dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg",
    phoneNumber: 2082204905,
    email: "foster154@gmail.com",
    hasExistingPledge: false,
    billingAddress: {
      addrLine1: null,
      addrLine2: null,
      city: null,
      state: "ID",
      zip: null,
    },
  },
  paymentMethods: [
    {
      ID: 1234,
      paymentType: "card",
      cardType: "mastercard",
      nickname: null,
      last4: "4532",
      expirationMonth: "04",
      expirationYear: "23",
      hasOtherOwner: false,
      owner: {},
      isDefaultPaymentMethod: true,
      isEnabledForTTG: false,
      sharedWithOtherHoH: false,
      isSaved: false,
    },
    {
      ID: 1235,
      paymentType: "card",
      cardType: "visa",
      nickname: null,
      last4: "9888",
      expirationMonth: "04",
      expirationYear: "23",
      hasOtherOwner: false,
      owner: {},
      isDefaultPaymentMethod: false,
      isEnabledForTTG: false,
      sharedWithOtherHoH: false,
      isSaved: false,
    },
  ],
};
